module.exports = __webpack_public_path__ + "static/img/3.7852256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20200828/3.png
// module id = DKcm
// module chunks = 1